import React from 'react'
import { tokenStore } from '../api'

// The token is written on a prior step and only read here, so there is nothing
// to subscribe to — hand back a no-op cleanup.
const subscribe = () => () => {}

// First-time setup === no session mfaToken.
const getSnapshot = (): boolean | null => !tokenStore.getMfaToken()

// Server snapshot retained for parity (CSR-only app uses the client snapshot).
const getServerSnapshot = (): boolean | null => null

/**
 * Resolves whether the current authenticator-app step belongs to a first-time
 * login setup (no session `mfaToken`) vs. a returning sign-in.
 */
export function useIsFirstTimeLogin(): boolean | null {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
